const initialState = {
	apartments: null,
	loading: false,
	error: null
}

const apartments = (state = initialState, action) => {
	switch (action.type) {
		case 'RESET_APP':
			return { ...initialState }
		case 'GET_APARTMENTS':
			return { ...state, loading: true, error: null }
		case 'GET_APARTMENTS_SUCCESS':
			return { ...state, apartments: action.payload, loading: false, error: null }
		case 'GET_APARTMENTS_FAIL':
			return { ...state, loading: false, error: action.payload }
		default:
			return state
	}
}

export default apartments
